// extracted by mini-css-extract-plugin
export var standaloneTable = "_gq-0";
export var standaloneTableWithBodyFill = "_gq-1";
export var withExtraHeader = "_gq-2";